import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator"; // 微信-点评吃喝玩乐

import Cookie from '../utils/cookie';
import Store from '../store';
var cityStoreKey = 'city';
export default {
  appName: 'dianping_chwl',
  useKNB: true,
  sellChannel: 3,
  theme: 'dianping',
  loginUrl: '///m.dianping.com/login?redir=',
  loginBetaUrl: '//m.51ping.com/login?redir=',
  ajaxUrl: '//m.dianping.com/myshow/ajax',
  ajaxBetaUrl: '//m.51ping.com/myshow/ajax',
  getUserInfo: function getUserInfo() {
    return {
      token: Cookie.get('dper')
    };
  },
  getLocation: function getLocation() {
    return {
      lat: Cookie.get('locallat'),
      lng: Cookie.get('locallng')
    };
  },
  getCity: function getCity() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var selectedCity;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Store.get(cityStoreKey);

            case 2:
              selectedCity = _context.sent;

              if (!(selectedCity && selectedCity.cityId)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", selectedCity);

            case 5:
              return _context.abrupt("return", {
                cityId: Cookie.get('cityid'),
                type: 'dp'
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};